module.exports = require("@swa-ui/core/src/List/List.module.scss");